import {getDate} from './chatGPTV2';

const streamUrl = `https://content.webapi-services.net/api/streaming/openai`;
let isMob = window.innerWidth < 768 && "ontouchstart" in document.documentElement ? true : false;

export let answer_time;

function formatToHTML(text) {
    let replacedText = text
    .replace(/\n/g, '<br>')  // Convert newlines to line breaks
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')  // Bold text
    .replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '<a href="$2">$1</a>');  // Convert markdown links to HTML links


    return replacedText;
}





export async function fetchAndStream(q, l,threadId) {

    let query = {
        input: decodeURIComponent(q),
        lang: l
    }

    if(threadId){query.threadId = threadId}

    const response = await fetch(streamUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // Add any other headers you need here
            },
            body: JSON.stringify(query) // or use the appropriate format for your data
        });
    
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const res1 = response.clone();
    const res2 = response.clone();
    const reader = res1.body.getReader();
    const decoder = new TextDecoder('utf-8');
    const outputDiv = document.querySelector('.pending-answer');
    let typing = document.querySelector('.typing');
    answer_time = getDate();

    let answer = "";

    if ( isMob ) {

        const rect = outputDiv.getBoundingClientRect();
        const scrollTop = document.documentElement.scrollTop;
        const elementTop = rect.top + scrollTop;

        window.scrollTo({
            top: elementTop - 120,
            behavior: 'smooth'
        });

        
    }


    // Function to process each chunk
    function processChunk({ done, value }) {
        if (done) {
            console.log("Stream complete");
            return res2.text();
        }

        // Decode and display the chunk
        const chunkText = decoder.decode(value, { stream: true });
       
        try {
            // answer += chunkText;
            const data = JSON.parse(chunkText);
            if (data.type === "messageDelta") {
                // console.log(data.data)
                answer += data.data;
                outputDiv.innerHTML = formatToHTML(answer);
                
                
            }
        } catch(x) {}
        // Continue reading the stream
        typing && typing.remove(); 
        return reader.read().then(processChunk);
    }

    const result = await reader.read().then(processChunk);
    return result;
}






